import { Outlet, Link, useLocation } from 'react-router-dom';
import '../css/Dashboard.css';

function DashboardLayout() {
  const location = useLocation();

  // Smarter match to avoid partial overlaps (like 'participants' in 'participants-data')
  const isActive = (path) => {
    const currentPath = location.pathname;
    return currentPath === path || currentPath.startsWith(`${path}/`);
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <nav className="dashboard-sidebar">
          <div className="sidebar-header">INCLASS</div>
          <ul>
            <li>
              <Link 
                to="/dashboard" 
                className={
                  location.pathname === '/dashboard' ? 'active' : ''
                }
              >
                Dashboard
              </Link>
            </li>

            <li>
              <Link 
                to="/dashboard/users" 
                className={isActive('/dashboard/users') ? 'active' : ''}
              >
                Benutzerverwaltung
              </Link>
              {isActive('/dashboard/users') && (
                <ul className="submenu">
                  <li>
                    <Link 
                      to="/dashboard/users/create" 
                      className={isActive('/dashboard/users/create') ? 'active' : ''}
                    >
                      + Neuer Benutzer
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <Link 
                to="/dashboard/participants" 
                className={
                  location.pathname.startsWith('/dashboard/participants') &&
                  !location.pathname.startsWith('/dashboard/participants-data')
                    ? 'active'
                    : ''
                }
              >
                Teilnehmerverwaltung
              </Link>
              {isActive('/dashboard/participants') && !isActive('/dashboard/participants-data') && (
                <ul className="submenu">
                  <li>
                    <Link 
                      to="/dashboard/participants/new" 
                      className={isActive('/dashboard/participants/new') ? 'active' : ''}
                    >
                      + Neuer Teilnehmer
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <Link 
                to="/dashboard/participants-data" 
                className={isActive('/dashboard/participants-data') ? 'active' : ''}
              >
                Teilnehmerdaten
              </Link>
            </li>

            <li>
              <Link 
                to="/dashboard/notifications" 
                className={isActive('/dashboard/notifications') ? 'active' : ''}
              >
                Zeitpläne
              </Link>
              {isActive('/dashboard/notifications') && (
                <ul className="submenu">
                  <li>
                    <Link 
                      to="/dashboard/notifications/new" 
                      className={isActive('/dashboard/notifications/new') ? 'active' : ''}
                    >
                      + Neuer Zeitplan
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link 
                to="/dashboard/sessions" 
                className={isActive('/dashboard/sessions') ? 'active' : ''}
              >
                Sitzungen
              </Link>
              {isActive('/dashboard/sessions') && (
                <ul className="submenu">
                  <li>
                    <Link 
                      to="/dashboard/sessions/new" 
                      className={isActive('/dashboard/sessions/new') ? 'active' : ''}
                    >
                      + Neue Sitzung
                    </Link>
                  </li>
                </ul>
              )}
            </li>


            {/* <li>
              <Link 
                to="/dashboard/ai-test" 
                className={isActive('/dashboard/ai-test') ? 'active' : ''}
              >
                AI Testung
              </Link>
            </li> */}


          </ul>
        </nav>

        <main className="dashboard-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
